import type { LocaleType } from "@crescentapplications/react-ui";

const FooterLogoLocales: LocaleType = {
  title: { ar: "أحمد الجمل", en: "Ahmad El Gamal" },
  subtitle: { ar: "الأصولي المالكي الأزهري", en: "Usuli Maliki Azhari" },
};

export default FooterLogoLocales;
